class ImageHotSpot {
	constructor(el) {
		this.el = el;
        this.targets = this.el.querySelectorAll('.target');
        this.contentWrappers = this.el.querySelectorAll('.content');

        this.eventHandlers();
	}

    eventHandlers() {
        this.targets.forEach( (el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const data = el.getAttribute('data-target');
                this.targets.forEach( (t) => {
                    t.classList.remove('active');
                })
                el.classList.add('active');
                this.contentWrappers.forEach( (cw) => {
                    cw.classList.remove('active')
                })
                const display = this.el.querySelectorAll(`[data-content="${data}"]`);
                display[0].classList.add('active');
            });
        });
	}
}

export default ImageHotSpot;